module.exports = __webpack_public_path__ + "static/media/log-out.50df8a43.svg";